export class StaticServer {
    private static readonly DEFAULT_SERVER = 'https://static.betgames.tv';

    private static readonly TIMEOUT = 2000;

    private static serverName: string;

    private static getRootDomain(): string {
        if (typeof window === 'undefined') {
            throw new Error('StaticServer can only be used in browser environment');
        }

        const parts = window.location.hostname.split('.');

        if (parts.length < 2) {
            throw new Error('Invalid hostname format');
        }

        return parts.slice(-2).join('.');
    }

    public static get name(): string {
        return this.serverName || this.DEFAULT_SERVER;
    }

    private static async pingServer(url: string): Promise<boolean> {
        try {
            const timeoutPromise = new Promise<never>((_, reject) => {
                setTimeout(() => reject(new Error('Request timeout')), this.TIMEOUT);
            });
            const fetchPromise = fetch(url, {
                method: 'HEAD',
                cache: 'no-cache',
            });
            const response = await Promise.race([fetchPromise, timeoutPromise]);

            return response.ok && response.status < 400;
        } catch (error) {
            return false;
        }
    }

    public static async configure(): Promise<void> {
        try {
            const rootDomain = this.getRootDomain();
            const staticUrl = `https://static.${rootDomain}`;
            const isReachable = await this.pingServer(staticUrl);

            this.serverName = isReachable ? staticUrl : this.DEFAULT_SERVER;
        } catch {
            this.serverName = this.DEFAULT_SERVER;
        }
    }
}
